import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DEFAULT_FLOW_PATH, PATH_URL } from 'src/helpers'
import { QuizQuestionContext } from '../contextAPI'
import { QuizType } from 'src/pages/shared'

interface IQuizProgressBarProps {
  quizType?: QuizType
}

export const getDefaultFlowPercentage = (pathname: string): number | null => {
  const pathIndex = DEFAULT_FLOW_PATH.indexOf(pathname)
  if (pathIndex < 0) {
    return null
  }
  return Math.round((pathIndex / (DEFAULT_FLOW_PATH.length - 1)) * 100)
}

export const getPinterestFlowPercentage = (pathname: string): number => {
  switch (pathname) {
    case PATH_URL.PINTEREST_AVAILABILITY:
      return 13
    case PATH_URL.YOUR_DETAILS:
      return 25
    case PATH_URL.NEW_BUDGET_PAGE:
      return 38
    case PATH_URL.PINTEREST_LINK_YOUR_BOARD:
      return 50
    case PATH_URL.NEW_COLOR_PALETTE_PAGE:
      return 63
    case PATH_URL.PLANNING_STAGE:
      return 75
    case PATH_URL.GUEST_COUNT:
      return 88
    default:
      return 100
  }
}

export const QuizProgressBar = ({ quizType }: IQuizProgressBarProps) => {
  const { quizProgressPercent, setQuizProgressPercent } = useContext(QuizQuestionContext)
  const [percentage, setPercentage] = useState(quizProgressPercent)
  const { pathname } = useLocation()

  useEffect(() => {
    const nextPercentage =
      quizType === QuizType.PINTEREST ? getPinterestFlowPercentage(pathname) : getDefaultFlowPercentage(pathname)

    if (nextPercentage === null) {
      return
    }

    setPercentage(nextPercentage)
    setQuizProgressPercent(nextPercentage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, quizType])

  return (
    <>
      <div className={'quiz-progress-bar'}>
        <div className="progress-percentage" style={{ width: `${percentage}%` }}></div>
      </div>
    </>
  )
}
